import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiSubmitWithdrawOrDepositTx } from "@/api";
import type { SubmitWithdrawOrDepositTxRequest } from "@/api/types";

/**
 * 提交充值或提现交易
 */
export const useSubmitWithdrawOrDepositTx = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: SubmitWithdrawOrDepositTxRequest) => {
      console.log(data, "submitWithdrawOrDepositTx");
      const response = await ApiSubmitWithdrawOrDepositTx(data);
      console.log(response.data, "submitWithdrawOrDepositTx response");
      return response.data;
    },
    onSuccess: () => {
      // 提交成功后刷新相关数据
      queryClient.invalidateQueries({
        queryKey: ["withdrawAndRechargeRecord"],
      });
      queryClient.invalidateQueries({ queryKey: ["balanceV2"] });
    },
  });
};
